export default __webpack_public_path__ + "df8670230c49f9955a22883a2a62fc25.svg";